import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from 'src/app/core/services/http/api.service'
import { environment } from 'src/environments/environment'

import { Model } from '../../models/other-module'
import { UploadOrchestratorService } from './upload-orchestrator.service'

@Injectable()
export class FileUploaderService {
  constructor(private readonly api: ApiService, private readonly uploadOrchestrator: UploadOrchestratorService) {}

  addMedia(body: FormData, options?: { silent?: boolean }) {
    return this.uploadOrchestrator.uploadAsMedia(body, options)
  }

  // Open/close a window during which all uploads (including ones the editor triggers
  // for inline images) stay out of the global upload-progress overlay.
  beginSilentUploadScope() {
    this.uploadOrchestrator.beginSilentScope()
  }

  endSilentUploadScope() {
    this.uploadOrchestrator.endSilentScope()
  }

  convertToPdf(id: string, wait = false) {
    return this.api.sendRequest({
      apiBase: `${environment.apiBase}/api/v2/`,
      method: 'post',
      endpoint: `document/${id}/convert-to-pdf?wait=${wait}`
    })
  }

  updateMedia(body: FormData, mediaId: string) {
    return this.api.sendRequest({
      apiBase: `${environment.apiBase}/api/v2/`,
      method: 'put',
      endpoint: `media/upload-file/${mediaId}`,
      body
    })
  }

  uploadTempMedia(body: FormData): Observable<{ key: string }> {
    return this.api.sendRequest({
      apiBase: `${environment.apiBase}/api/v2/`,
      method: 'post',
      endpoint: 'media/upload-temp-media',
      body
    })
  }
  // MAX AI document extraction for the create flows (DT / FAQ / article / LMS).
  // Only called on the MODEL_1 path — every caller skips this and sends the raw
  // objectKey to the create API when the model is MODEL_2 (Gemini extracts the
  // document natively, with AI, and supports images).
  //   MODEL_1 -> media/extract-content : buffer-based, no AI markdown pass.
  //              DOCX/DOC go through Apache Tika; PDF/TXT read text from the buffer.
  //   MODEL_2 -> media/extract-markdown : heavier AI documentToMarkdown conversion.
  //              (kept for completeness; not hit by the current create flows.)
  extractContent(objectKey: string, model_choice: Model): Observable<{ markdown: string; content: string }> {
    if (model_choice === Model.MODEL_2) {
      return this.api.sendRequest({
        apiBase: `${environment.apiBase}/api/v2/`,
        method: 'post',
        endpoint: 'media/extract-markdown',
        body: {
          objectKey
        }
      })
    } else
      return this.api.sendRequest({
        apiBase: `${environment.apiBase}/api/v2/`,
        method: 'post',
        endpoint: 'media/extract-content',
        body: {
          objectKey
        }
      })
  }

  extractSOPMarkdown(objectKey: string): Observable<{ markdown: string }> {
    return this.api.sendRequest({
      apiBase: `${environment.apiBase}/api/v2/`,
      method: 'post',
      endpoint: 'media/extract-sop-markdown',
      body: {
        objectKey
      }
    })
  }
  uploadSopTempMedia(body: FormData): Observable<{ key: string }> {
    return this.api.sendRequest({
      apiBase: `${environment.apiBase}/api/v2/`,
      method: 'post',
      endpoint: 'media/upload-sop-temp-media',
      body
    })
  }

  deleteMedia(id, faqId?: string, mediaRefId?: string) {
    return this.api.sendRequest({
      apiBase: `${environment.apiBase}/api/v2/`,
      method: 'delete',
      endpoint: `media/${id}`,
      queryParams: {
        mediaRefId,
        faqId
      }
    })
  }
}
